const getEnv = (key: string): string | undefined => {
  if (typeof process !== 'undefined' && process.env?.[key]) return process.env[key];
  if (typeof import.meta !== 'undefined') return (import.meta as any).env?.[key];
  return undefined;
};

export const readLLMEnabledFlag = (): boolean => {
  if (typeof localStorage === 'undefined') return false;
  return localStorage.getItem('enpass_llm_enabled') === 'true';
};

// 模型模式配置
export type ModelMode = 'fast' | 'quality';

const MODEL_MODE_KEY = 'enpass_model_mode';

export const MODEL_OPTIONS: Record<ModelMode, { name: string; desc: string; model: string }> = {
  fast: {
    name: '极速',
    desc: '更快响应，适合快速练习',
    model: 'google/gemini-3-flash-preview',
  },
  quality: {
    name: '精准',
    desc: '更准确的表达建议，适合精细打磨',
    model: 'google/gemini-3-flash-preview',
  },
};

export const readModelMode = (): ModelMode => {
  if (typeof localStorage === 'undefined') return 'quality';
  const mode = localStorage.getItem(MODEL_MODE_KEY);
  return mode === 'fast' ? 'fast' : 'quality';
};

export const setModelMode = (mode: ModelMode): void => {
  if (typeof localStorage === 'undefined') return;
  localStorage.setItem(MODEL_MODE_KEY, mode);
};

export const getSelectedModel = (): string => {
  const mode = readModelMode();
  return MODEL_OPTIONS[mode].model;
};

// readOpenRouterKey 已删除 - 前端不应直接访问 API Key，所有请求走后端代理

const toNumber = (val: string | undefined, fallback: number) => {
  const num = Number(val);
  return Number.isFinite(num) ? num : fallback;
};

export const readLLMTimeouts = () => ({
  providerTimeoutMs: toNumber(getEnv('VITE_LLM_PROVIDER_TIMEOUT_MS'), 8000),
  totalTimeoutMs: toNumber(getEnv('VITE_LLM_TOTAL_TIMEOUT_MS'), 12000),
});

export type LLMLogPayload = {
  provider: string;
  latencyMs?: number;
  error?: unknown;
  event?: 'success' | 'failure';
};

export const getLLMLogger = (): ((msg: string, extra?: unknown) => void) => {
  if (typeof window !== 'undefined' && (window as any).__enpass_llm_logger) {
    return (window as any).__enpass_llm_logger;
  }
  return (msg: string, extra?: unknown) => console.warn(msg, extra);
};
